import { render, staticRenderFns } from "./VehicleAttributeSelector.vue?vue&type=template&id=ea31f55c"
import script from "./VehicleAttributeSelector.vue?vue&type=script&lang=ts"
export * from "./VehicleAttributeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports